import { ModuleDto } from "../../dtos/ModuleDto";
import { ApiResult, apiWrapperWithError } from "./ApiUtils";

export const getGrantModules = async (grantId: string): Promise<ApiResult<ModuleDto[]> | null> => {
    return apiWrapperWithError<ModuleDto[]>(`api/grants/${grantId}/modules`, 'GET', `fetching modules for grant with ID ${grantId}`);
}

export const enableGrantModule = async (grantId: string, moduleTypeId: number): Promise<ApiResult<boolean> | null> => {
    return apiWrapperWithError<boolean>(`api/grants/${grantId}/modules/${moduleTypeId}`, 'PUT', `enabling module for grant with ID ${grantId}`);
}
